import React, { useState, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";

import { Link, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

import Tippy from "@tippyjs/react";

import "tippy.js/dist/tippy.css";

import { isMobile } from "react-device-detect";

const Header = () => {
  const user = useSelector((state) => state.user.data || {}); // fallback to empty object

  const school = user.school;

  const { id } = useParams();

  const hash = window.location.hash.slice(5);

  const fullname = "OP";

  return (
    <>
      <div class="docs-header">
        <nav
          class={
            isMobile
              ? "navbar navbar-expand-lg navbar-default bg-white fixed-top py-3 shadow-none"
              : "navbar navbar-expand-lg fixed-top ms-0 py-3 shadow-none"
          }
        >
          <a class="d-flex text-lg-start text-center">
            <div className="col-12 text-center ms-9 ms-lg-0 mb-lg-0">
              <a className="fs-10 text-purple2">{school}</a>
            </div>
          </a>

          <ul class="navbar-nav ms-lg-auto ms-6 flex-row d-none d-lg-flex">

            <Link
              to="."
              class={
                hash === "/pay"
                  ? "nav-item docs-header-btn ms-4 text-dark-success"
                  : "nav-item docs-header-btn ms-4 text-purple2"
              }
            >
              <span className="fs-4"><i className="bi bi-cash fs-3"></i> SmartPay</span>
            </Link>

            <Link
              to="."
              class={
                hash === "/invite"
                  ? "nav-item docs-header-btn ms-4 text-dark-success"
                  : "nav-item docs-header-btn ms-4 text-purple2"
              }
            >
              <span className="fs-4"> <i className="bi bi-controller fs-3"></i> Game</span>
            </Link>

            <Link to={"/" + id + "/logout"} className="ms-4 d-none d-lg-flex">
              <button className="btn btn-danger btn-sm text-white fs-4 rounded-4 fwt">
                <i class="bi bi-power"></i> Logout
              </button>
            </Link>
          </ul>

          <ul class="navbar-nav ms-lg-auto ms-6 flex-row d-lg-none">

          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
